import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    vergeApp: null
  },
  mutations: {
    SET_CAMERA_KEY_CONTROL(state, chatState) {
      if (state.vergeApp.controls) {
        state.vergeApp.controls.enableKeys = chatState
      }
    },
    SET_VERGE_APP(state, app) {
      state.vergeApp = app
    }
  },
  actions: {},
  modules: {}
})
